import React, { useEffect, useState } from "react";
import "./esg.css";
import "../beratungsfeder.css";
import Kooperationspartner from "./Kooperationspartner";
import Opportunity from "./Opportunity";
import Reporting from "./Reporting";
import StatusQuo from "./StatusQuo";
import Strategy from "./Strategy";
import Sustainability from "./Sustainability";

import EsgCircle from "./EsgCircle";

import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";
import EbookForms from "../../EbookForms/EbookForms";
import SideIndex from "../../Transformations/SideIndex";
import { useParams } from "react-router-dom";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { getSideIndexList } from "../../Transformations/sideIndexItems";
import { Helmet, HelmetProvider } from "react-helmet-async";

const menuItems = [
	{ id: "ESG", label: "ESG-Beratung" },
	{ id: "status_quo", label: "ESG status quo" },
	{
		id: "reporting",
		label: "ESG Reporting & Communication",
	},
	{ id: "strategy", label: "ESG Strategy" },
	{
		id: "sustainability",
		label: "Financing Sustainability",
	},
	{
		id: "opportunity",
		label: "ESG Opportunity (ESG Data & AI for Impact)",
	},
	{
		id: "kooperationspartner",
		label: "Kooperationspartner",
	},
	{
		id: "esg_ebook",
		label: "ESG-Whitepaper",
	},
];

export default function ESGAdvisory() {
	const [cont, setCont] = useState(null);
	const [selList, setSelList] = useState(null);

	const [showCont, setShowCont] = useState(0);

	const { subType } = useParams("subType");
	const [indexList, setIndexList] = useState(getSideIndexList("esg"));
	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const setMenu = (elemId) => {
		if (selList) {
			selList.classList.remove("active");
		}
		const listItem = document.getElementById(elemId);

		listItem.classList.add("active");
		setSelList(listItem);
		setCont(elemId);
	};

	useEffect(() => {
		if (subType) {
			setMenu(subType);
		}
	}, [subType]);

	const showText = (e, name_id) => {
		var elemName = name_id;
		const liElement = document.getElementById(elemName);

		liElement.classList.add("article-effect");
		const pathElement1 = document.querySelector("path." + elemName);
		if (pathElement1) {
			pathElement1.attributes["stroke-width"].nodeValue = "2";
			pathElement1.style.transform = "scale(1.2)";
		}
	};
	const hideText = (e, name_id) => {
		var elemName = name_id;
		const liElement = document.getElementById(elemName);

		liElement.classList.remove("article-effect");
		const pathElement1 = document.querySelector("path." + elemName);
		if (pathElement1) {
			pathElement1.attributes["stroke-width"].nodeValue = "1";
			pathElement1.style.transform = "scale(1)";
		}
	};

	return (
		<div className="beratungsfeder immobil mobile-esg">
			<div className="side-menu esg-menu">
				<aside>
					<ul className="side-navigation">
						<li className="category">ESG-Beratung</li>
						<ul className="article_links">
							{menuItems.map((item, index) => (
								<li
									key={item.id}
									id={item.id}
									data-sec={item.id}
									className={
										selList || index > 0
											? "article-link-item"
											: "article-link-item active"
									}
									onMouseEnter={(e) => showText(e, item.id)}
									onMouseLeave={(e) => hideText(e, item.id)}
								>
									<button
										aria-label="menu-btn"
										className="link_button_sd"
										onClick={() => setMenu(item.id)}
									>
										{item.label}
									</button>
								</li>
							))}
						</ul>
					</ul>
				</aside>
			</div>
			<div className="mobile-menu-side">
				<Box sx={{ maxWidth: "100%", bgcolor: "background.paper" }}>
					<Tabs
						value={value}
						onChange={handleChange}
						variant="scrollable"
						scrollButtons
						allowScrollButtonsMobile
					>
						{indexList
							? indexList.list.map((item, index) => (
									<Tab
										key={index}
										value={index}
										label={item.label}
										onClick={(e) => setMenu(item.id)}
										wrapped
									/>
							  ))
							: ""}
					</Tabs>
				</Box>
			</div>
			<div
				className="beratungsfeder-content"
				onClick={(e) => setShowCont("Beratung")}
			>
				{cont === "status_quo" ? (
					<StatusQuo />
				) : cont === "reporting" ? (
					<Reporting />
				) : cont === "strategy" ? (
					<Strategy />
				) : cont === "sustainability" ? (
					<Sustainability />
				) : cont === "opportunity" ? (
					<Opportunity />
				) : cont === "kooperationspartner" ? (
					<Kooperationspartner />
				) : cont === "esg_ebook" ? (
					<EbookForms type="esg" />
				) : (
					<>
						<h1>ESG-Beratung</h1>
						<div className="intro-cont">
							<HelmetProvider>
								<Helmet>
									<title>ESG-Beratung</title>
									<meta name="description" content="ESG Beratung" />
									<meta
										name="keywords"
										content="ESG , Assets , Feingeist, Berlin"
									/>
								</Helmet>
							</HelmetProvider>
							<p>
								Unser ESG Team begleitet Sie kompetent in strategischen und
								operativen Fragestellungen in den Aspekten Umwelt, Soziales und
								Governance (ESG). Dabei setzen wir nicht nur die
								„regulatorischen Pflichtbausteine“ um, sondern optimieren auf
								Ihren Wunsch hin unter Einsatz von Technologie mit Fokus KI auch
								Ihren ESG-Reifegrad, der wiederum starke Signalwirkung auf die
								Stakeholder und Ihre Marktpositionierung hat.
							</p>
							<p>
								Die positiven Effekte auf die Arbeitgeberattraktivität sowie die
								Analyse nachhaltiger Wachstumspotenziale sind ebenfalls wichtige
								Elemente einer Nachhaltigkeitsstrategie. Unsere fünf Services
								für Ihre nachhaltige Positionierung:
							</p>
						</div>
						<div className="esg-new-circle">
							<EsgCircle
								setMenu={() => setMenu}
								showText={showText}
								hideText={hideText}
							/>
						</div>
					</>
				)}
			</div>
			<button
				aria-label="kontct-btn"
				className="show-kontact"
				onClick={(e) => setShowCont(showCont != 2 ? 2 : 0)}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="16"
					height="16"
					fill="currentColor"
					className="bi bi-telephone"
					viewBox="0 0 16 16"
				>
					<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
				</svg>
			</button>
			<aside className={showCont != 2 ? "contact-sec" : "contact-sec open-sec"}>
				<p className="contact-person">
					<span className="contact-patener">Ansprechpartnerin </span>
					<img src="https://feingeist-beratung.de/wp-content/uploads/2023/12/foto-2.jpg" />
					<span>Vanessa Just</span>
					<span>Partnerin für ESG Advisory</span>
				</p>
				<p>
					Setzen Sie sich mit uns in Verbindung und lassen Sie sich
					unverbindlich beraten.
				</p>
				<a className="link-button" href="/kontakt">
					Kontaktieren Sie uns
				</a>
			</aside>
		</div>
	);
}
